import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import useSportsStore from 'hooks/useSportsStore';
import Seo from 'components/seo';
import usePostMessage from 'hooks/UsePostMessage';
import SoccerContainer from './container';
import style from './style.module.scss';
import SoccerWrapper from './wrapper';
import { timeUtils } from '../../../common/utils/timeUtil';

const Soccer = observer(() => {
  const scoreRef = useRef();
  const store = useSportsStore('soccer');
  const { postMessageInit, resetParentFrame } = usePostMessage();
  const [today] = useState(timeUtils.todayYmd());
  const [currentDate, setCurrentDate] = useState(today);

  useEffect(() => {
    postMessageInit();
    store.getSoccerToday();
    store.getTodayFinalCount();
    store.getFavoriteGames();

    return () => {
      store.closeSocket();
    };
  }, []);

  const onChangePage = (date) => {
    store.getSoccer(date);
  };
  console.log(store);
  return (
    <div className={style.livescore_wrap} ref={scoreRef} id='soccer_board'>
      <Seo
        title='네임드스코어:축구,라이브스코어,실시간스코어,실시간중계'
        description='네임드 스코어 - 전세계 모든 경기의 라이브스코어, 실시간스코어, 실시간문자중계 정보 제공'
        path={window.location.pathname}
      />
      <SoccerContainer
        onChangePage={onChangePage}
        count={store.soccerCount}
        selectedTab={store.selectedTab}
        setSelectedTab={store.setSoccerSelectedTab}
        getSoccerToday={store.getSoccerToday}
        todayFinalCount={store.todayFinalCount}
        getTodayFinalSoccer={store.getTodayFinalSoccer}
        clearSearchValue={store.clearSearchValue}
        getTodayFinalCount={store.getTodayFinalCount}
        getFavoriteTodayGameIds={store.getFavoriteTodayGameIds}
        getSoccerInterestGames={store.getSoccerInterestGames}
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
        today={today}
      >
        <SoccerWrapper
          loading={store.loading}
          list={store.soccerList.list}
          finishedList={store.soccerList.finishedList}
          selectedGameList={store.selectedList}
          selectedTab={store.selectedTab}
          selectedGames={store.selectedGames}
          setSelectedGame={store.setSelectedGame}
          scoreRef={scoreRef}
          resetParentFrame={resetParentFrame}
          nextDate={timeUtils.datePrevOrNext(currentDate, 'next')}
          prevDate={timeUtils.datePrevOrNext(currentDate, 'prev')}
          currentDate={currentDate}
          onChangePage={onChangePage}
          setCurrentDate={setCurrentDate}
          setSelectedTab={store.setSoccerSelectedTab}
          today={today}
          getTodayFinalSoccer={store.getTodayFinalSoccer}
        />
      </SoccerContainer>
    </div>
  );
});

export default Soccer;
